$(document).ready(function (params) {
  $(".product-slider-mobile .slider-content").slick({
    adaptiveHeight: false,
    // fade: true,
    speed: 500,
    slide: ".slide",
    infinite: true,
    swipe: true,
    swipeToSlide: true,
    slidesToShow: 1, 
    slidesToScroll: 1, 
    arrows: false,
    // centerMode: true,
    centerPadding: ($('.product-slider-mobile .slider-content').find('>div').outerWidth() / 1.5) + 'px',
    // variableWidth: true
  });

  $('.product-slider .slider-content').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    // fade: true,
    speed: 500,
    slide: ".slide",
    infinite: true,
    swipe: true,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768, // Ajuste para pantallas de hasta 768px (tablet y mobile)
        settings: {
          slidesToShow: 1, // Muestra 1 ítem en mobile
          slidesToScroll: 1
        }
      }
    ]
  })

  // Add custom progress bar
  $(".product-slider .slider-content").on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var progress = (nextSlide + 1) * (100 / slick.slideCount) + '%';
      $(this).parent('.product-slider').find('.slick-progress span').css('width', progress);
  });
  $(".product-slider-mobile .slider-content").on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var progress = (nextSlide + 1) * (100 / slick.slideCount) + '%';
      $(this).parent('.product-slider-mobile').find('.slick-progress span').css('width', progress);
  });
});